import { NavLink } from "react-router-dom";

const UnitsNavBar = () => {
  return (
      <nav>
		  <ul>
			  <li>
				  <NavLink to="/addUnit">Add Unit</NavLink>
			  </li>
			  <li>
				  <NavLink to="/editUnit">Edit Unit</NavLink>
			  </li>
			  <li>
				  <NavLink to="/deleteUnit">Delete Units</NavLink>
			  </li>
			  <li>
				  <NavLink to="/restoreUnit">Restore Deleted Units</NavLink>
			  </li>			  
		  </ul>
      </nav>
  );
};

export default UnitsNavBar;
